export default "__VITE_ASSET__C45lUF28__"